import { render, staticRenderFns } from "./ManageBankAccountDetail.vue?vue&type=template&id=65286a16"
import script from "./ManageBankAccountDetail.vue?vue&type=script&lang=js"
export * from "./ManageBankAccountDetail.vue?vue&type=script&lang=js"
import style0 from "./ManageBankAccountDetail.vue?vue&type=style&index=0&id=65286a16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports